// extracted by mini-css-extract-plugin
module.exports = {"summary":"_3M3S4b","summaryLink":"_5jzGny"};